import Phaser from 'phaser'

export default class ScanHint extends Phaser.GameObjects.Container {
  constructor (scene) {
    super(scene, 1100, 620)

    const bg = this.scene.add.image(0, 0, 'white').setTint(0).setDisplaySize(400, 140).setRotation(-0.08)
    this.add(bg)

    const bar = this.scene.add.image(110, -90, 'white').setTint(0).setDisplaySize(150, 10).setRotation(-0.08)
    this.add(bar)

    const text = this.scene.add.image(0, 0, 'hud', 'hold_space').setRotation(0.03)
    this.add(text)

    this.setAlpha(0)

    this.scene.player.once('has-moved', () => {
      this.scene.tweens.add({
        duration: 300,
        targets: this,
        alpha: 1,
        delay: 800
      })
    })
    this.scene.player.once('looking', () => {
      this.scene.tweens.add({
        duration: 100,
        targets: this,
        x: '+=400',
        alpha: 0,
        onComplete: () => this.destroy()
      })
    })

    const resize = () => {
      if (this.scene) {
        this.x = 1100 + (this.scene.scale.width - 1280) / 2
        this.y = 620 + (this.scene.scale.height - 720)
      }
    }
    this.scene.scale.on('resize', resize)
    resize()
  }
}
